module.exports = __webpack_public_path__ + "img/arrow-black.106f95bf.svg";